import React from 'react';

import { ImageDeleteIcon } from 'src/app/components/icons/image-delete-icon';
import { Card, Image, DeleteButton } from 'src/app/components/lib/image-card/image-card.styles';

type ImageCardProps = {
  automationId?: string;
  disabled?: boolean;
  icon?: React.ReactNode;
  isThumbnail?: boolean;
  onButtonClick?: () => void;
  src: string;
};

export function ImageCard(props: ImageCardProps) {
  const {
    automationId = 'image-card',
    disabled = false,
    src,
    icon = <ImageDeleteIcon disabled={props.disabled} />,
    isThumbnail,
    onButtonClick,
  } = props;

  return (
    <Card $isThumbnail={isThumbnail}>
      <Image src={src} />
      {onButtonClick && (
        <DeleteButton data-testid={automationId} disabled={disabled} onClick={onButtonClick}>
          {icon}
        </DeleteButton>
      )}
    </Card>
  );
}
